import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ExcludedStateCodeListModel, ListStateCodeModel } from 'src/app/models/excluded-statecode/excluded-state-code.model';
import { UrlHelperService } from 'src/app/services/Common/urlhelper.service';
import { ExcludedStatecodeService } from 'src/app/services/excluded-statecode.service';
import { ExcludeStatecodeDeleteComponent } from './exclude-statecode-delete/exclude-statecode-delete.component';

@Component({
  selector: 'app-excluded-statecode',
  templateUrl: './excluded-statecode.component.html',
  styleUrls: ['./excluded-statecode.component.css']
})
export class ExcludedStatecodeComponent implements OnInit {
  excludedStateCodeListing: ExcludedStateCodeListModel = new ExcludedStateCodeListModel();
  excludedStateCodeListVM: ListStateCodeModel = new ListStateCodeModel();
  Loader: boolean = false;
  searchValue: string = "";
  id: number;

  constructor(private urlHelperService: UrlHelperService, private modalService: NgbModal, private router: Router, private excludedStateCode: ExcludedStatecodeService) {
    this.excludedStateCodeListing = new ExcludedStateCodeListModel();
    this.excludedStateCodeListVM = new ListStateCodeModel();
  }

  ngOnInit() {
    this.ExcludedStateCodeListing();
  }

  resetFilter() {
    this.searchValue = "";
    this.excludedStateCodeListVM.Keyword = this.searchValue;
    this.ExcludedStateCodeListing();
  }

  filter() {
    this.excludedStateCodeListVM.Keyword = this.searchValue;
    this.ExcludedStateCodeListing();
  }

  ExcludedStateCodeListing() {
    this.Loader = true;
    this.excludedStateCode.ExcludedStateCodeListing(this.excludedStateCodeListVM)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.Loader = false;
          this.excludedStateCodeListing.excludedStateCodeListModel = responseBody.responseData;
        }
        (err) => {
          this.Loader = false;
        }
      });
  }

  ExcludedStateCodeDetail(excludedStateCodeDetail) {
    this.router.navigate(['/excluded-statecode-update/' + excludedStateCodeDetail.id]);
  }

  DeleteExcludedStateCode(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this.excludedStateCode.passId(item.id);
    let modalRef = this.modalService.open(ExcludeStatecodeDeleteComponent, modalConfig);
    modalRef.result.then(() => {
    }, (reason) => {
      this.ExcludedStateCodeListing();
    })

  }
}
